import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { companyQuery } from "#modules/company/infra/company.query";
import { updateCompany } from "#modules/company/infra/updateCompany.api";

export const useUpdateCompany = () => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: updateCompany,
    onSuccess: () => {
      void queryClient.invalidateQueries(companyQuery());
      showSuccessToast({ title: "L'entreprise a été mise à jour" });
    },
    onError: (err) => {
      showErrorToast({ title: "Une erreur est survenue" });
      errorHandler(err);
    },
  });

  return { updateCompany: mutate, ...rest };
};
